
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class AmfyTable extends Vue {
    //澳门风云
    table = {
        data: [],
        column: [
            {
                title: '底分',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).Hit && JSON.stringify(JSON.parse(params.row.opt_detail).Hit) != '{}') {
                        let indexnum = Object.keys(JSON.parse(params.row.opt_detail).Hit)[0]
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).Hit[indexnum].base)
                    } else if (JSON.parse(params.row.opt_detail).point) {
                        str = (this as any).getMoney(JSON.parse(params.row.opt_detail).point)
                    } else {
                        str = '/'
                    }
                    return h('span', str)
                }
            },
            {
                title: '中奖倍数',
                align: 'center',
                render: (h, params) => {
                    let str: any
                    if (JSON.parse(params.row.opt_detail).Hit) {
                        let indexnum = Object.keys(JSON.parse(params.row.opt_detail).Hit)
                        str = 0
                        indexnum.forEach((item) => {
                            str += Number(JSON.parse(params.row.opt_detail).Hit[item].rate * JSON.parse(params.row.opt_detail).Hit[item].multi)
                        })
                    } else {
                        str = '/'
                    }
                    return h('span', str)
                }
            },
            {
                title: '当局图案及顺序',
                align: 'center',
                render: (h, params) => {
                    let arr = []
                    if (JSON.parse(params.row.opt_detail).Award) {
                        arr = JSON.parse(params.row.opt_detail).Award
                    }
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: arr.map((item, i) => {
                                    return "<img style='width:35px;' src=img/gameImg/amfy/" + item[0] + '.png>'
                                })
                            }
                        }),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: arr.map((item, i) => {
                                    return "<img style='width:35px;' src=img/gameImg/amfy/" + item[1] + '.png>'
                                })
                            }
                        }),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: arr.map((item, i) => {
                                    return "<img style='width:35px;' src=img/gameImg/amfy/" + item[2] + '.png>'
                                })
                            }
                        })
                    ])
                }
            }
        ]
    }

    @Prop()
    listdata
}
